// settings.js 

export const MAINTENANCE_CODE_CURRENT = 77;
export const MAINTENANCE_CODE_LVL1 = 78;
export const MAINTENANCE_CODE_LVL2 = 79;
export const MAINTENANCE_CODE_LVL10 = 142;
export const VESC_ADC_5V = 120;

const onRequestExport = (deviceProps, settingsRaw) => {
    const json = JSON.stringify(settingsRaw);
    const blob = new Blob([json], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = deviceProps?.ble_name ? `settings-${deviceProps?.ble_name}.json` : `settings-${deviceProps?.mac_custom}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

const getSettingDescriptionById = (settingsDescription, bleId) => {
    const param = settingsDescription.parameters;

    for (const [key, value] of Object.entries(param)) {
        const entriesSettings = Object.entries(param[key].settings);
        if (entriesSettings) {
            for (const [key, value] of entriesSettings) {
                if (value["ble_id"] == bleId) {
                    return value;
                }
            }
        }
    }
};

function findClassNameByBleId(data, bleId) {
    for (let key in data.parameters) {
        let settingsArray = data.parameters[key].settings;
        for (let i = 0; i < settingsArray.length; i++) {
            if (settingsArray[i].ble_id === bleId) {
                return data.classes[key].en;
            }
        }
    }
    return null;
}

function getListStringsByBleId(parameters, bleId, rawValue) {
    let desc = getSettingDescriptionById(parameters, bleId);
    if (desc && desc.smartphone_display_type === "list") {
        let splittedValues = desc.list_strings.split("\n");
        return splittedValues[rawValue] + " [" + rawValue + "]";
    } else if (desc && desc.smartphone_display_type === "checkbox") {
        return rawValue ? "true" : "false";
    } else {
        return rawValue;
    }
}

export {
    onRequestExport,
    getSettingDescriptionById,
    findClassNameByBleId,
    getListStringsByBleId
};